import { render, staticRenderFns } from "./NoticeListing.vue?vue&type=template&id=bc594426&"
import script from "./NoticeListing.vue?vue&type=script&lang=js&"
export * from "./NoticeListing.vue?vue&type=script&lang=js&"
import style0 from "./NoticeListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports